<template>
  <AdminLayout><DeliveredOrdersTable /></AdminLayout>
</template>

<script>
import AdminLayout from '../AdminLayout.vue';
import DeliveredOrdersTable from './DeliveredOrdersTable.vue';

export default {
  name: 'DeliveredOrders',
  components: { AdminLayout, DeliveredOrdersTable },
};
</script>
